module.exports = __webpack_public_path__ + "static/media/calendar-arrow-right-green.a6fa01a5.svg";